export default {
  freightSourceShipownerTitle: '船东',
  freightSourcePeerTitle: '同行',
  freightSourceAgentPriceTitle: '代理约价',
  exportUserTitle: '导出人',
  exportStatusTitle: '导出状态',
  exportFreightTitle: '导出运价',
  exportScopeLockedTitle: '导出范围已锁定',
  exportScopeLockedDesc: '将全量导出当前用户权限范围内的已上架运价，未上架、已失效和已删除数据不会进入文件。',
  selectExportTemplateTitle: '选择导出模板',
  confirmExportButton: '确认导出',
  exportTemplateRouteCategoryName: '按航线分类模板',
  exportTemplateRouteCategoryDesc: '按航线输出一行，横向展示各箱型价格与附加费信息。',
  exportTemplateCargoWiseName: 'CargoWise 模板',
  exportTemplateCargoWiseDesc: '字段与按航线模板一致，按 CargoWise Excel 样式输出源数据。',
  exportSuccessDownloadRecordPrompt: '操作成功，请前往下载记录查看',
  dataUpdatingPrompt: '数据修改中，请等待'
}
